module.exports = __webpack_public_path__ + "static/media/hub_cluster.2873665f.svg";